(ns iris.core
  (:require
   ["react-dom/client" :refer [createRoot]]
   [reagent.core :as r]
  ;;  [reagent.dom :as rdom]
   [goog.dom :as gdom]
   [re-frame.core :as re-frame]
   [day8.re-frame.http-fx]
   [cljs.core.async :refer [<! >! go chan put! alts! go-loop timeout]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.config :as config]


   [iris.fingerprint] ; Side-effect: starts fingerprint collection
   [iris.websocket.init :as ws-init]


   [iris.auth.api :as auth]
   [iris.data.api :as data]
   [iris.globals :as globals]
   [iris.utils :as utils]
   [goog.functions]
   [goog.dom.ViewportSizeMonitor]
   [goog.userAgent]
   [goog.events]
   [clojure.string :as string]
   [clerk.core :as clerk]
   [iris.routes :as routes]
   [iris.events :as events]
   [iris.views :as views]

   [iris.localstorage :as localstorage]
   [iris.sessionstorage :as sessionstorage]

   [iris.indexeddb :as idb]

   [iris.posts.events :as posts-events]

   [iris.login.events :as login-events]

   [iris.worker-pool :as worker-pool]
   
   
   [iris.tags.events :as tags-events]
   
   [iris.firebase :as firebase]))







(defn dev-setup []
  (when config/debug?
    (println "dev mode")))



;; (defonce root (createRoot (gdom/getElement "app")))

(defn ^:dev/after-load mount-root []
  (re-frame/clear-subscription-cache!)
  ;; (let [root-el (.getElementById js/document "app")]
    ;; (rdom/unmount-component-at-node root-el)
    ;; (rdom/render [views/main-panel] root-el)
    (let [root (createRoot (gdom/getElement "app"))]
      (.render root (r/as-element [views/main-panel])))

    ;; )
  )


(defn set-mobile [m]
  (re-frame/dispatch [::events/set-mobile m]))

(defn set-viewport-size [d]
  (let [w (aget d "width")
        h (aget d "height")]
    (re-frame/dispatch [::events/set-viewport-size w h])))

(defn is-mobile? []
  (or goog.userAgent.MOBILE (utils/iOS13+iPad)))

(defn attach-viewport-size-monitor []
  (set-mobile (is-mobile?))
  (let [vsm (goog.dom.ViewportSizeMonitor.)]
    (set-viewport-size (.getSize vsm))
    (.listen goog.events vsm goog.events.EventType.RESIZE
             (goog.functions/debounce #(set-viewport-size (.getSize vsm)) 1000))))

(defn attach-scroll-event-listener []
  ;; TODO: check if google closure lib has scroll event
  ;; also make sure it's not attached multiple times
  (.addEventListener
   js/window
   "scroll"
   (goog.functions/debounce
    (fn []
      (let [scrollTop (.. js/document -documentElement -scrollTop)]
        (re-frame/dispatch [::events/set-scroll-top scrollTop]))) 500)))

;; used for firebase default ws sync, switching to local storage
;; (defn sync-default-ws []
;;   (go
;;     (<p! (fb/auth-promise))
;;     (let [ws (or (<p! (fb/<p-get-defaults-ws)) "TLO")]
;;       ;; (re-frame/dispatch [::events/set-ws ws])
;;       (re-frame/dispatch [::events/set-ws-sync ws]))))


(defn sync-default-ws-from-session-storage []
  (let [ws (sessionstorage/get-item "iris.defaults.ws")]
    ;; (re-frame/dispatch [::events/set-ws ws])
    (re-frame/dispatch [::events/set-ws-sync ws])
    ws))

;;
;; (defn async-default-ws-from-firebase []
;;   (println "async-default-ws-from-firebase")
;;   (go
;;     (let [user (<! (fb/wait-for-auth-user-with-timeout 5000))]
;;       (cond (.-uid user)
;;             (do
;;               (js/console.log "User signed in:" (.-uid user))
;;               (let [ws (or (<p! (fb/<p-get-defaults-ws))
;;                            ;;  "TLO" ;; this needs to be first item from list of websites user is allowed to see
;;                            (first (:websites @globals/jwt-payload)))]
;;                 (println "async-default-ws-from-firebase: ws:" ws @globals/jwt-payload)
;;                 (sessionstorage/set-item! "iris.defaults.ws" ws)
;;                 (re-frame/dispatch [::events/set-ws-sync ws])))
;;             (= user :auth-timeout)
;;             (do
;;               (js/console.warn "No user after 5s – continuing unauthenticated.")
;;               (let [ws (first (:websites @globals/jwt-payload))]
;;                 (println "NO async-default-ws-from-firebase: ws:" ws @globals/jwt-payload)
;;                 (sessionstorage/set-item! "iris.defaults.ws" ws)
;;                 (re-frame/dispatch [::events/set-ws-sync ws])))))))


(defn async-default-ws-from-firebase []
  (println "async-default-ws-from-firebase")
  (auth/wait-for-user-with-timeout
   5000
   (fn [user]
     (if user
       (do
         (js/console.log "User signed in:" (.-uid user))
         ;;  (let [ws (or (<p! (fb/<p-get-defaults-ws))
         ;;               ;;  "TLO" ;; this needs to be first item from list of websites user is allowed to see
         ;;               (first (:websites @globals/jwt-payload)))]
         ;;    (println "async-default-ws-from-firebase: ws:" ws @globals/jwt-payload)
         ;;    (sessionstorage/set-item! "iris.defaults.ws" ws)
         ;;    (re-frame/dispatch [::events/set-ws-sync ws]))


         (.then (data/get-default-ws-with-fallback (first (:websites @globals/jwt-payload)))
                (fn [ws]
                  (js/console.log "Retrieved value:" ws)
                  (println "async-default-ws-from-firebase: ws:" ws @globals/jwt-payload)
                  (sessionstorage/set-item! "iris.defaults.ws" ws)
                  (re-frame/dispatch [::events/set-ws-sync ws]))))

       (do
         (js/console.warn "No user after 5s – continuing unauthenticated.")
         (let [ws (first (:websites @globals/jwt-payload))]
           (println "NO async-default-ws-from-firebase: ws:" ws @globals/jwt-payload)
           (sessionstorage/set-item! "iris.defaults.ws" ws)
           (re-frame/dispatch [::events/set-ws-sync ws]))
         (re-frame/dispatch [::events/add-msg {:debug-message "Firebase auth timeout – sync skipped"}])
         (auth/on-auth-ready #(re-frame/dispatch [::events/add-msg {:info "Firebase auth ready"}])))))))


(defn sync-default-ws []
  (println "sync-default-ws")
  (if-let [ws (sessionstorage/get-item "iris.defaults.ws")]
    (re-frame/dispatch [::events/set-ws-sync ws])
    ;; exec on signin - this can't be right. what if sign in never happens?
    ;; (swap! globals/exec-on-fb-sign-in #(conj @globals/exec-on-fb-sign-in async-default-ws-from-firebase))
    (async-default-ws-from-firebase)))

(defn sync-raid-len []
  (if-let [raid-len (localstorage/get-item "iris.post.raid-len")]
    (re-frame/dispatch [::events/set-raid-len (int raid-len)])
    (do
      (re-frame/dispatch [::events/set-raid-len globals/RAID_LEN_DEFAULT])
      (localstorage/set-item! "iris.post.raid-len" globals/RAID_LEN_DEFAULT))))

(defn sync-text-resizer []
  (if-let [font-size (localstorage/get-item "iris.post.font-size")]
    (re-frame/dispatch [::posts-events/set-font-size (int font-size)])
    (do
      (re-frame/dispatch [::posts-events/set-font-size globals/FONT_SIZE_DEFAULT])
      (localstorage/set-item! "iris.post.font-size" globals/FONT_SIZE_DEFAULT))))


;; (defn ^:dev/after-load mount-root []
;;   (re-frame/clear-subscription-cache!)
;;   (let [root-el (.getElementById js/document "app")]
;;     (rdom/unmount-component-at-node root-el)
;;     (rdom/render [views/main-panel] root-el)))



;; intercept anchor link click events
;; in order to scroll to already active anchor link
;; get hash from the currently clicked anchor target element
;; if it matches the current win location hash, rewrite history
;; (to get rid of current hash)
;; and assign it again
(defn intercept-click-event [e]
  (let [target (.-target e)]
    (when (= (.-tagName target) "A")
      (when-let [href (.getAttribute target "href")]
        (let [hash (-> href
                       (.split "#")
                       (aget 1))]
          (when-not (nil? hash)
            (let [loc-hash (-> (.. js/window -location -hash)
                               (.substring 1))]
              (when (= hash loc-hash)
                (.preventDefault e)
                (.replaceState js/history nil nil " ")
                (set! (.. js/window -location -hash) hash)))))))))


;; ;; https://clojureverse.org/t/how-to-replace-cljs-http-client-get-with-js-fetch/9490
;; (defn fetch-post [ruid]
;;   (let [jwt @globals/jwt]
;;     (js/fetch js/apolloURL
;;               (clj->js {:method "POST"
;;                         :headers {:authorization (str "Bearer " jwt)
;;                                   :content-type "application/json"}
;;                         :body (js/JSON.stringify (clj->js {:jsonrpc "2.0"
;;                                                            :id 0
;;                                                                                       ;; :method "Post.Get"
;;                                                            :method "Post2a.Get"
;;                                                            :params {:options {:debug false}
;;                                                                     :data {:ruid ruid
;;                                                                            :include_screening_status false}}}))}))))
;; TODO: refactor or use more specific function name
;; intercepts <a> tag mouseover events for .ref.pref (post id references),
;; extracts ids/ruid from href, fetches the post and caches it to indexeddb for use in local state
;; where it is saved as a nested map with the post article id (paruid) containing nested ref ids (ruid)
(defn intercept-mouseover-event [e]
  (let [target (.-target e)]
    (when (= (.-tagName target) "A")
      (when (true? (-> target
                       (.matches ".ref.pref")))
        (posts-events/load-post-ref-from-a-pref-mouseover-event target)))))





(def touch-event (atom nil))
(def touchstart-ch (chan))
(def touchend-ch (chan))
(def touchcancel-ch (chan))

(defn intercept-touchstart-event [e]
   (put! touchstart-ch e))

(defn intercept-touchend-event [e]
  (put! touchend-ch e))

(defn intercept-touchcancel-event [e]
  (put! touchcancel-ch e))

(defn intercept-long-touch-event [e]
  (intercept-mouseover-event (.-detail e)))


(defn attach-long-touch-event-listener []
  (.addEventListener js/document "touchstart" intercept-touchstart-event)
  (.addEventListener js/document "touchend" intercept-touchend-event)
  (.addEventListener js/document "touchcancel" intercept-touchcancel-event)

  (.addEventListener js/document "long-touch-event" intercept-long-touch-event)

  (go-loop []
    (let [[key ch] (alts! [touchstart-ch
                           touchend-ch
                           touchcancel-ch
                           (timeout 500)])]
      (condp = ch
        touchstart-ch (do
                        (reset! touch-event key))
        touchend-ch (do
                      (when (nil? @touch-event)
                        (println "PREVENTING DEFAULT ON touchend-ch (need to uncomment)")
                    ;; (.preventDefault key)
                    ;; (.stopPropagation key)
                        )
                      (reset! touch-event nil))
        touchcancel-ch (do
                          ;;  (reset! touch-event nil)
                         )
        (do
          (when-not (nil? @touch-event)
              ;; (.preventDefault @touch-event)
              ;; (.stopPropagation @touch-event)
            (.dispatchEvent
             js/document
             (new js/CustomEvent "long-touch-event" #js {:bubbles true, :composed true :detail @touch-event}))
            (reset! touch-event nil)))))
    (recur)))




(defn init []
  
;; ;; (when-let [channel globals/fb-broadcast-channel]
;;   (set! (.-onmessage globals/fb-broadcast-channel)
;;         (fn [event]
;;           (println "Received message:" (.-data event))))
;;   ;; )


  (clerk/initialize!)
  (clerk/navigate-page! (.. js/document -location -origin)) ;; hack to take you to anchor on load

  (.addEventListener js/document "click" intercept-click-event)

  (if (is-mobile?)
    (attach-long-touch-event-listener)
    (.addEventListener js/document "mouseover" intercept-mouseover-event))


  ;; (.addEventListener js/document "mouseover" intercept-mouseover-event)

  (.addEventListener js/document "aut-logout-event"
                     (fn [e]
                       (.log js/console "aut-logout-event e:" e)
                       (login-events/logout)))



  ;; (.addEventListener js/document "touchstart" intercept-touchstart-event)
  ;; (.addEventListener js/document "touchend" intercept-touchend-event)
  ;; (.addEventListener js/document "touchcancel" intercept-touchcancel-event)

  ;; (.addEventListener js/document "long-touch-event" intercept-long-touch-event)




  ;; (go-loop []
  ;;   (let [[key ch] (alts! [touchstart-ch
  ;;                          touchend-ch
  ;;                          touchcancel-ch
  ;;                          (timeout 500)])]
  ;;     (condp = ch
  ;;       touchstart-ch (do
  ;;                       (reset! touch-event key)
  ;;                       (.log js/console "touchstart-ch" key)
  ;;                       (.log js/console "touchstart-ch" @touch-event))
  ;;       touchend-ch (do
  ;;                     (.log js/console "touchend-ch" key)
  ;;                     (.log js/console "touchend-ch" @touch-event)
  ;;                     (when (nil? @touch-event)
  ;;                       (println "PREVENTING DEFAULT ON touchend-ch (need to uncomment)")
  ;;                 ;; (.preventDefault key)
  ;;                 ;; (.stopPropagation key)
  ;;                       )
  ;;                     (reset! touch-event nil))
  ;;       touchcancel-ch (do
  ;;                        (.log js/console "touchcancel-ch" key)
  ;;                        (.log js/console "touchcancel-ch" @touch-event)
  ;;                       ;;  (reset! touch-event nil)
  ;;                        )
  ;;       (do
  ;;         (.log js/console "touch-timeout-ch" @touch-event)
  ;;         (when-not (nil? @touch-event)
  ;;           (.log js/console "touch-timeout-ch (.-target @touch-event)" (.-target @touch-event))
  ;;           ;; (.preventDefault @touch-event)
  ;;           ;; (.stopPropagation @touch-event)
  ;;           (.dispatchEvent
  ;;            js/document
  ;;            (new js/CustomEvent "long-touch-event" #js {:bubbles true, :composed true :detail @touch-event}))
  ;;           (reset! touch-event nil)))))
  ;;   (recur))


  (.addEventListener js/document "DOMContentLoaded"
                     (fn [event]
                       (routes/start!)
                       (re-frame/dispatch-sync [::events/initialize-db])

                       (ws-init/start!) ; NEW: Start WebSocket after db initialization
                       
                      ;;  (sync-default-ws)
                      ;;  (sync-default-ws-from-session-storage)
                       ;; set default ws from firebase by adding it to globals/exec-on-fb-sign-in (gets run in fb/sign-in method)
                      ;; switching default ws to local storage
                        ;; (swap! globals/exec-on-fb-sign-in #(conj @globals/exec-on-fb-sign-in sync-default-ws))


                      ;;  (sync-default-ws)

                       (sync-raid-len)
                       (sync-text-resizer)

                       (dev-setup)
                       (mount-root)
                       (attach-viewport-size-monitor)
                      ;;  (attach-scroll-event-listener)

                      ;;  (worker-pool/init!)


                       (add-watch globals/fbjwt :fbjwt-observer
                                  (fn [key atom old-val new-val]
                                    ;; if first time setting fbjwt, init firebase
                                    ;; if renewing fbjwt, just sign in with new fbjwt


                                    ;; (fb/init!)
                                    (println "fbjwt observer:" key old-val new-val)

                                    (when-not (auth/authenticated?)
                                      (auth/init-auth! new-val)
                                      (worker-pool/init!)
                                      (sync-default-ws))



                                    ;; (when (zero? (alength fb-app/apps))
                                    ;;   (fb/firebase-init))

                                    ;; (when (some? new-val)
                                    ;;   (fb/sign-in)
                                    ;;   (worker-pool/do-all! {:handler :fb-sign-in, :arguments {:data new-val}}))

                                    ;; (when (and (nil? new-val) (not (zero? (alength firebase/apps))))
                                    ;;   (sign-out))


                                    ;; TODO: possibly relocate worker related code elsewhere?
                                    ;; (let [worker-pool (worker-main/create-pool 2 js/webWorkerFile)
                                    ;;       print-result (fn [result-chan]
                                    ;;                      (go
                                    ;;                        (let [result (<! result-chan)]
                                    ;;                          (.debug js/console (str "MAIN>WORK::" result))
                                    ;;                          result)))]

                                    ;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :mirror, :arguments {:a "Hallo" :b "Welt" :c 10}}))
                                    ;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :mirror, :arguments {:a "Hallo" :b "Welt" :c 10 :d (js/ArrayBuffer. 10) :transfer [:d]} :transfer [:d]}))
                                    ;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :test-fb, :arguments {:eid "c:edehwodbttqtywo7dyrdsyazkhulaes662o5pakncfjcllxoaom6r3mry6yklfqks7beh5w2yfy63"}})))
                                    ))
                                    
                                    
                                    
                                    (add-watch globals/jwt :jwt-observer
                                               (fn [key atom old-val new-val]
                                                 (when-let [jwt new-val]
                                                   (let [jwt-payload (login-events/get-jwt-payload jwt)
                                                         uid (:uid jwt-payload)
                                                         env (:env jwt-payload)
                                                         tier js/window.tier
                                                         msg {:info (str "Logged in Iris, env " env ", tier " tier ", as " uid)}]
                                                     (re-frame/dispatch [::events/add-msg msg]))
                                                   (re-frame/dispatch [::tags-events/load-autotags-list jwt "TLO"]))))
                                    
                                    
                                    
                                    )))
